<template>
  <div class="box1">
    <div class="top">
      <!-- <p>
        企业服务器安全稳定<br />
        运行的掌舵者
      </p>
      <h1><i>AI </i>运维</h1>
      <b></b> -->
      <img src="../../../assets/coursePage/linux/box1/top.png"/>
    </div>
    <div class="bottom">
      <ul>
        <img class="bg" src="../../../assets/coursePage/linux/box1/ele.png"/>
        <li>
          <img src="../../../assets/coursePage/linux/box1/dot.png"/>
          <span>
            <h1>Linux系统运维能力</h1>
            <p>满足企业级服务器运维需求</p>
          </span>
        </li>
        <li>
          <img src="../../../assets/coursePage/linux/box1/dot.png"/>
          <span>
            <h1>自动化运维能力</h1>
            <p>满足企业自动化部署、自动化运维需求</p>
          </span>
        </li>
        <li>
          <img src="../../../assets/coursePage/linux/box1/dot.png"/>
          <span>
            <h1>云计算能力</h1>
            <p>满足企业级公有云、私有云、容器运设计需求</p>
          </span>
        </li>
        <li>
          <img src="../../../assets/coursePage/linux/box1/dot.png"/>
          <span>
            <h1>Python开发能力</h1>
            <p>解决企业级运维开发需求</p>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.box1 {
  background: #F0F6FF;
  .bottom{
    width: 690px;
    padding: 40px 0 40px 40px;
    box-sizing: border-box;
    background: linear-gradient( 144deg, #FFFFFF 0%, #F0F8FF 100%);
    box-shadow: 0px 12px 16px 0px rgba(190,215,255,0.3);
    border-radius: 24px;
    position: relative;
    top: -82px;
    left: 30px;
    ul{
      li{
        display: flex;
        align-items: flex-start;
        margin-bottom: 32px;
        position: relative;
        z-index: 2;
        img{
          width: 24px;
          margin: 8px 8px 0 0;
        }
        span{
          h1{
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 26px;
            color: #0155FF;
            line-height: 40px;
            text-align: left;
            font-style: normal;
            margin-bottom: 8px;
          }
          p{
            font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 24px;
color: #68778F;
line-height: 40px;
text-align: left;
font-style: normal;
          }
        }
      }
      li:last-child{margin-bottom: 0 ;}
    }
    .bg{
      width: 346px;
      position: absolute;
      top:24px;
      right: 0;
    }
  }
  .top {
   
    width: 100%;
    img{
      width: 100%;
    }
   
  }
}
</style>
